<li [class.disabled]="!location.active">
  <span class="inline-block h-4 w-4">
    <ng-container *ngIf="selectedLocation.name === location.name; else default">
      <svg
        class="animate-pop-in"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none">
        <circle cx="9" cy="9" r="8.5" stroke="#55C57A" />
        <circle cx="9" cy="9" r="6" fill="#55C57A" />
      </svg>
    </ng-container>
    <ng-template #default>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none">
        <circle cx="9" cy="9" r="8.5" stroke="var(--color-border-strong)" />
      </svg>
    </ng-template>
  </span>
  <div class="dark:bg-white ml-2 mr-2">
    <img class="" src="{{ logo }}" alt="Right Logo" class="w-8 h-8" />
  </div>
  <div class="flex flex-col">
    <span class="truncate text-text font-bold leading-none">
      {{ business }}
    </span>
    <div>
      <span
        class="text-supporting-text text-sm font-normal leading-4 single-line">
        {{ location.name }}
      </span>
      <span class="font-light" *ngIf="location.active == false">&#8856;</span>
    </div>
  </div>
</li>
